export enum FeatureToggle {
  storefront = 'rt_storefront',
  navigationCollections = 'rt_retailer_collections_navigation_v2',
  retailerCollectionsV2 = 'retailer_collections_v2_enabled',
  RetailerCollectionsV2Ux = 'rt_retailer_collections_ux_v2',
  autosuggestLinksRedirectType = 'rt_autosuggest_links_redirect_type',
  unataRetailersOnIPP = 'rt_unata_retailers_on_ipp',
  openContentPageFlyoutNavigationAction = 'rt_storefront_content_page_flyout_modals',
  campaignManagementContentPageIppDrafts = 'rt_campaign_management_content_ipp_drafts',
  campaignManagementCreativeManager = 'rt_campaign_management_creative_manager',
  campaignManagementContentPageIppPreviews = 'rt_campaign_management_content_ipp_previews',
  pageBuilderSingleRetailer = 'rt_pagebuilder_single_retailer',
  brandingV2 = 'rt_ipp_branding_v2',
}
